import { Download } from 'lucide-react';
import { resumeData } from '../data/resume';
import HeroSection from '../components/resume/HeroSection';
import SummarySection from '../components/resume/SummarySection';
import ExperienceTimeline from '../components/resume/ExperienceTimeline';
import SkillsSection from '../components/resume/SkillsSection';
import EducationSection from '../components/resume/EducationSection';

export default function Resume() {
  return (
    <div className="min-h-screen">
      <HeroSection personalInfo={resumeData.personalInfo} />
      <SummarySection summary={resumeData.summary} />
      <ExperienceTimeline experience={resumeData.experience} />
      <SkillsSection skills={resumeData.skills} />
      <EducationSection
        education={resumeData.education}
      />
      
      {/* Download Resume Button */}
      <section className="border-t border-gray-200 py-12 dark:border-gray-800">
        <div className="container text-center">
          <a
            href="https://assets.rathor.dev/Resume_Ravindra_Singh_MERN_ATS.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary inline-flex items-center gap-2"
          >
            <Download size={20} />
            Download Resume PDF
          </a>
        </div>
      </section>
    </div>
  );
}
